/**
 * Valid grades for a Classroom, a Student, or a Teacher.
 */
export const MIN_GRADE_LEVEL = 0; // Kindergarten
export const MAX_GRADE_LEVEL = 12;
